import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { storyDetailsRoute } from "../../routes/routesPath";
import { getSlug } from "../../utils/helpers";
import StoryCard from "../storyCard/homeStoryCard";

const EmblaCarousel = ({ slides = [], slideOptions = {}, autoScrollOptions = {} }) => {
  const options = {
    loop: true,
    dragFree: true,
    duration: 60,
    dragThreshold: 100,
  };

  const [emblaRef, emblaApi] = useEmblaCarousel({ ...options, ...slideOptions }, [
    AutoScroll({
      playOnInit: true,
      speed: 0.5,
      stopOnInteraction: false,
      direction: "backward",
      ...autoScrollOptions,
    }),
  ]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides?.map((story) => (
            <div className="embla__slide" key={story._id}>
              <a
                key={story._id}
                href={`${storyDetailsRoute}/${getSlug(story.title)}/${story._id}`}
                target="_blank"
                rel="noreferrer"
                className="my-2 text-decoration-none text-dark d-inline-block">
                <StoryCard story={story} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmblaCarousel;
